// src/config/tenantConfig.js

// Read the environment variable (Defaults to BRIGHTSPARC if missing)
const tenant = process.env.REACT_APP_TENANT || 'BRIGHTSPARC';

const configs = {
    BRIGHTSPARC: {
        id: 'BRIGHTSPARC',
        name: 'BrightSparc',
        primaryColor: '#2C365E',
        logo: '/assets/brightsparc-logo.png',

        heroTitle: 'Modernizing Education Funding.',
        heroSubtitle: 'BrightSparc is South Africa\'s secure, cloud-native platform connecting ambitious students with dedicated funders. Say goodbye to manual spreadsheets and fragmented applications.',
        contactEmail: 'support@brightsparc.co.za',
        contactPhone: '+27 coming soon',
        
        // --- FEATURE TOGGLES ---
        features: {
            showCareerIntelligence: true, 
            showBillingDashboard: true,   
            showGlobalBursaries: true,
            showReports: true,      // 🚨 NEW: Admin Reports Toggle
            showTemplates: true,    // 🚨 NEW: Admin Templates Toggle
            showContracts: true,     // 🚨 NEW: Admin Contracts Toggle            
            // 🚨 INDIVIDUAL FEATURE ENABLERS (Turn on/off per tenant)
            showVibeCheckGame: false,    // Set to true to enable the 60-second Vibe Check game
            showMarketPulse: true,      // Set to true to enable Weekly Market Pulse for JB Marks
            showEmailQueue: true,
            enableDocRequests: false,   // 🚨 Parked Oct 2026 — see server request-documents route
        }
    },
    JBMARKS: {
        id: 'JBMARKS',
        name: 'JB Marks Education Trust Fund',
        primaryColor: '#8b7d53', 
        logo: '/assets/jbmarks-logo.png',
        logoUrl: 'https://storage.googleapis.com/brightsparc-public-assets/logos/1778822198372-jbmarks_logo-removebg-preview.png',

        heroTitle: 'Human Capacity Building Through Education.',
        heroSubtitle: 'The JB Marks Education Trust Fund was established by the National Union Mineworkers (NUM) in 1997 to empower members and their dependents, particularly members in the mining, energy, construction, and metal sectors. The Trust is named after John Beaver Marks, a leading figure in the mineworkers’ struggle against exploitation. He was a vocal advocate of education as an empowerment tool and a vital weapon in the fight against poverty.',
        contactEmail: 'info@jbmarksedutrust.co.za',
        contactPhone: '+27 11 492 0601',
        
        // --- FEATURE TOGGLES ---
        features: {
            showCareerIntelligence: false, // 🚨 Turns off Vibe Game & Market Pulse for JB Marks applicants
            showBillingDashboard: false,   
            showGlobalBursaries: false,     
            showReports: true,     // 🚨 NEW: Hides Reports for JB Marks Admin
            showTemplates: true,   // 🚨 NEW: Hides Templates for JB Marks Admin
            showContracts: true,   // 🚨 NEW: Hides Contracts for JB Marks Admin
            showFundAmount: false,             
            // 🚨 INDIVIDUAL FEATURE ENABLERS (Turn on/off per tenant)
            showVibeCheckGame: false,    // Set to true to enable the 60-second Vibe Check game
            showMarketPulse: true,      // Set to true to enable Weekly Market Pulse for JB Marks
            showEmailQueue: true,
            enableDocRequests: false    // 🚨 Parked Oct 2026 — not commissioned by client
        }
    }
};

export const tenantConfig = configs[tenant] || configs['BRIGHTSPARC'];
